import React from "react";
import { Link } from "react-router-dom";

import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChatHeader: React.FC = () => (
	<header className="flex items-center gap-3 border-b border-neutral-200 px-4 py-3">
		<Link
			to="/analytics"
			className="flex items-center gap-2 text-sm text-neutral-500 hover:text-neutral-700"
			aria-label="Back to Reporting & Analytics"
		>
			<FontAwesomeIcon icon={faArrowLeft} />
			<span>Reports</span>
		</Link>
		<div className="h-4 w-px bg-neutral-200" />
		<h1 className="text-base font-semibold text-neutral-800">Ask AI</h1>
	</header>
);

export default ChatHeader;
